export const ROLES = {
    ADMIN: 'ROLE_ADMIN',
    USER: 'ROLE_USER',
    VIEWER: 'ROLE_VIEWER'
};

export const filterMenuByRole = (menu, userRole) => {
    if (!userRole) {
        return menu.filter(item => 
            item.label === 'Menu' && item.items?.some(subItem => 
                ['/login', '/register'].includes(subItem.to)
            )
        ).map(item => ({
            ...item,
            items: item.items.filter(subItem => ['/login', '/register', '/confirm-register', '/forgot-password', '/confirm-forgotpassword'].includes(subItem.to))
        }));
    }

    if (userRole === ROLES.ADMIN) {
        return menu.map(item => {
            if (item.label === 'Menu') {
                return {
                    ...item,
                    items: item.items.filter(subItem => 
                        !['/login'].includes(subItem.to)
                    )
                };
            }
            return item;
        });
    }

    if (userRole === ROLES.USER) {
        return menu.filter(obj => obj.label === 'Menu' || obj.label === 'Home').map(item => {
            if (item.label === 'Menu') {
                return {
                    ...item,
                    items: item.items.filter(subItem => 
                        ['/forgot-password', '/confirm-forgotpassword','/users-confirmation', '/logout'].includes(subItem.to)
                    )
                };
            } else if (item.label === 'Home') {
                return {
                    ...item,
                    items: item.items.filter(subItem => 
                        ['/'].includes(subItem.to)
                    )
                };
            }
            return item;
        });
    }

    return [];
};
